import { Injectable } from '@angular/core';
import { WOJ } from './wojewodztwa'
import { AnalysisService } from 'app/services/analysis.service';

declare var google: any;

export enum EnumWojewodztwo {
  lub,
  maz,
  podk,
  swiet
}

@Injectable()
export class WojewodztwaService {

  polyWoj: google.maps.Polygon;
  polyMazWoj: google.maps.Polygon;
  polyLubWoj: google.maps.Polygon;
  polySwietWoj: google.maps.Polygon;
  polyPodkWoj: google.maps.Polygon;

  constructor(private analysisService: AnalysisService) {
  }



  checkLocation(lat: number, lng: number): boolean {
    if (this.polyWoj === undefined) {
      this.polyWoj = new google.maps.Polygon({ paths: [WOJ.pathWojewodztwa] });
    }
    const position = new google.maps.LatLng(lat, lng);
    if (google.maps.geometry.poly.containsLocation(position, this.polyWoj)) {
      return true;
    } else {
      return false;
    }
  }

  initPolyWoj(woj: EnumWojewodztwo) {
    if (woj === EnumWojewodztwo.lub) {
      if (this.polyLubWoj === undefined) {
        this.polyLubWoj = new google.maps.Polygon({ paths: [WOJ.pathLubelskie] });
      }
      return this.polyLubWoj;
    } else if (woj === EnumWojewodztwo.maz) {
      if (this.polyMazWoj === undefined) {
        this.polyMazWoj = new google.maps.Polygon({ paths: [WOJ.pathMazowieckie] });
      }
      return this.polyMazWoj;
    } else if (woj === EnumWojewodztwo.podk) {
      if (this.polyPodkWoj === undefined) {
        this.polyPodkWoj = new google.maps.Polygon({ paths: [WOJ.pathPodkarpackie] });
      }
      return this.polyPodkWoj;
    } else if (woj === EnumWojewodztwo.swiet) {
      if (this.polySwietWoj === undefined) {
        this.polySwietWoj = new google.maps.Polygon({ paths: [WOJ.pathSwietokrzyskie ] });
      }
      return this.polySwietWoj;
    }
  }

  checkWojewodztwo(woj: EnumWojewodztwo) {
    const loc = this.analysisService.getDachLocation();

    return this.checkWojLocation(loc.lat(), loc.lng(), woj);
  }

  checkWojLocation(lat: number, lng: number, woj: EnumWojewodztwo): boolean {
    const poygonWoj = this.initPolyWoj(woj);
    const position = new google.maps.LatLng(lat, lng);
    if (google.maps.geometry.poly.containsLocation(position, poygonWoj)) {
      return true;
    } else {
      return false;
    }
  }
}



// WEBPACK FOOTER //
// /Users/michaldudziak/Desktop/Projekty/Projekt-Sunroof/Sunroof/src/app/services/wojewodztwa.service.ts